<div class="forgot-password-container">
  <section>
    <app-loading *ngIf="isLoading" />
    <form *ngIf="!isShowMessage && !loginHint" [formGroup]="form" (ngSubmit)="onSubmit()" class="forgot-password-form">
      <div class="w-full gap-30">
        <div class="title">
          {{ 'Forgot Password' | translate }}
        </div>
        <div class="description">
          {{ 'Please enter your email address to reset your password.' | translate }}
        </div>
        <mat-form-field class="mat-form-field" appearance="outline">
          <mat-label>{{ 'Email' | translate }}</mat-label>
          <input id="email" formControlName="email" type="email" matInput required placeholder="{{ 'Email' | translate }}" />
          <mat-icon matSuffix class="material-icons-outlined">email</mat-icon>
        </mat-form-field>
      </div>
      <app-button [label]="'button.Next' | translate" type="submit" />
    </form>
    <app-forgot-password-message
      *ngIf="isShowMessage"
      [email]="this.email.value"
      (handleTryAgain)="handleForgotPassword(this.email.value)"
      [isLoading]="isLoading"
    />
    <app-migrated-user-prompt *ngIf="loginHint" [loginHint]="loginHint" [promptContent]="promptContent" [title]="promptTitle" />
  </section>
</div>
